<template>
  <div class="send-repeat-tip">
    <el-dialog title="提示" :visible.sync="visible" :before-close="closeDialog" width="720px" :close-on-click-modal="false">
      <div v-if="this.dialogData.type == 'SELF_SIX_HOURS'">
        <div class="mix-tip">重复发送同一票会造成垃圾舱单！</div>
        <p>系统检测到您正在重复发送舱单！</p>
        <p>随意重复发送会导致垃圾舱单，请立即<el-link type="primary" :underline="false" @click="toQQ">联系客服</el-link>进行处理～</p>
        <WTable :WTableOpts="WTableOpts"></WTable>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" class="submit-btn" style="width:104px" @click="toQQ">联系客服</el-button>
        </div>
      </div>
      <div v-if="this.dialogData.type == 'SELF_THIRTY_DAYS'">
        <div class="mix-tip">重复发送同一票会造成垃圾舱单！</div>
        <p>系统检测到您正在重复发送舱单！</p>
        <p>随意重复发送会导致垃圾舱单，请立即<el-link type="primary" :underline="false" @click="toQQ">联系客服</el-link>进行处理～</p>
        <WTable :WTableOpts="WTableOpts"></WTable>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeDialog">取消</el-button>
          <!-- <el-button type="primary" class="submit-btn" @click="enterGo">我已确认，继续</el-button> -->
        </div>
      </div>
      <div v-if="this.dialogData.type == 'OTHERS_THIRTY_DAYS'">
        <div class="mix-tip">重复发送同一票会造成垃圾舱单！</div>
        <p>以下提单号您的同事已经发过，建议确认后再发送～</p>
        <WTable :WTableOpts="WTableOpts"></WTable>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeDialog">取消</el-button>
          <!-- <el-button type="primary" class="submit-btn" @click="enterGo">我已确认，继续</el-button> -->
        </div>
      </div>
      <div v-if="this.dialogData.type == 'OTHERS_COMPANY_THIRTY_DAYS'">
        <div class="mix-tip">重复发送同一票会造成垃圾舱单！</div>
        <p>以下提单号其他企业已经发送过，请咨询客服～</p>
        <WTable :WTableOpts="WTableOpts"></WTable>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeDialog">取消</el-button>
          <el-button style="width:104px;color:#1170EB;border:1px solid #1170EB;" @click="toQQ">联系客服</el-button>
          <!-- <el-button type="primary" class="submit-btn" @click="enterGo">我已确认，继续</el-button> -->
        </div>
      </div>
      <div v-if="this.dialogData.type == 'CONTAINERNO_EXISTS'">
        <div class="mix-tip">重复发送同一票会造成垃圾舱单！</div>
        <p>以下箱号已存在，建议确认后再发送～</p>
        <WTable :WTableOpts="WTableOptsNo"></WTable>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeDialog">取消</el-button>
          <el-button style="width:104px;color:#1170EB;border:1px solid #1170EB;" @click="toQQ">联系客服</el-button>
          <!-- <el-button type="primary" class="submit-btn" @click="enterGo">我已确认，继续</el-button> -->
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: "SendRepeatTip",
  props: {
    visible: Boolean,
    sendStatus:{
      type:Number,
      default:1
    },
    dialogData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      WTableOpts: {
        data: [],
        tableAttrs: { border: false },
        tableColAttrs: [
          { prop: 'masterBillNo', label: '重复主提单号'},
          { prop: 'houseBillNo', label: '重复分提单号'}
        ]
      },
      WTableOptsNo: {
        data: [],
        tableAttrs: { border: false },
        tableColAttrs: [
          { prop: 'containerNo', label: '重复箱号'},
        ]
      }
    }
  },
  created() {
    console.log(this.dialogData,1111111)
    this.WTableOpts.data = this.dialogData.content
    this.WTableOptsNo.data = this.dialogData.content
  },
  methods: {
    // 确认 继续
    enterGo(){
      this.$emit("enterGo", this.dialogData)
    },
    // 联系客服
    toQQ(){
      window.open('https://wpa1.qq.com/yGWcFLfo?_type=wpa&qidian=true')
    },
    // 关闭
    closeDialog(){
      this.$emit("closeDialog")
    }
  }
}
</script>

<style scoped lang="less">
.send-repeat-tip {
  color: #333333;
  font-size: 14px;
  .dialog-footer {
    text-align: right;
    margin-top: 24px;
  }
  .el-button {
    height: 32px;
  }
  .submit-btn {
    width: 146px;
    padding: 0;
  }
  /deep/.el-dialog__body {
    position: relative;
    padding: 42px 24px 24px 24px !important;
  }
  .mix-tip {
    background: #fff5ed;
    color: #ed6a0c;
    width: 100%;
    height: 32px;
    line-height: 32px;
    padding-left: 16px;
    box-sizing: border-box;
    position: absolute;
    left: 0;
    top: 0;
  }
  .balance-box {
    font-weight: 500;
    text-align: right;
    margin-top: 24px;
    .balance-num {
      color: #f58d0b;
      font-size: 16px;
      margin-right: 4px;
      margin-left: 16px;
    }
  }
  /deep/.el-link {
    vertical-align: top;
  }
}
</style>